import { render, staticRenderFns } from "./user-role-card.vue?vue&type=template&id=367196da&scoped=true&"
import script from "./user-role-card.vue?vue&type=script&lang=js&"
export * from "./user-role-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367196da",
  null
  
)

export default component.exports